import React from 'react'
import { isInvestor } from '../../../../global/authentication/authentication-manager.js'

function OverviewContent({ fundStory }) {
  let strippedHtml = fundStory

  if (isInvestor()) {
    strippedHtml = removeManagedAccountMsg(strippedHtml)
    strippedHtml = addInvestorDomain(strippedHtml)
  }

  strippedHtml = addQaAutomationTag(strippedHtml)

  return (
    <div
      id="fund-story-content"
      className={`Grid Content`}
      dangerouslySetInnerHTML={{ __html: strippedHtml }}
    />
  )
}

function removeManagedAccountMsg(fundstory) {
  const start = fundstory.indexOf(
    '<p class="u-borderColorNeutralLight u-borderBottom u-borderTop u-borderLeft u-borderRight u-inlineBlock u-padding3gu">Also available as a'
  )
  const end = fundstory.indexOf('</p>', start)
  let subStr = ''

  if (start >= 0 && end >= 0) {
    subStr = fundstory.substring(start, end + 4)
  }

  return fundstory.replace(subStr, '')
}

function addQaAutomationTag(fundstory) {
  return fundstory.replace(
    'data-settings="playlistId:',
    'data-qa-automation="video" data-settings="playlistId:'
  )
}

function addInvestorDomain(fundstory) {
  return fundstory.replace(
    '/investment-products',
    '/investor/investment-products'
  )
}

export default OverviewContent